import React, { useState } from "react";
import styled from "styled-components";
import MainLayout from "../../layouts/mainLayout/mainLayout";
import MyCalendarView from '../../components/myCalendar/myCalendar'
import Input from "../../components/input/input";
import Button from "../../components/button/button";
import { Colors } from "../../utilities/colors";
import './myCalendar.css';
import { useSnapshot } from "valtio";
import { useEffect } from "react";
import { getApplications,getSchedules,getTalentUserData } from "../../services/apiCalls";
import { mycalendarProxy } from "./mycalendarproxy";
import Dropdown from "../../components/dropdown/dropdown1";
import HamburgerLay from "../../components/hamburger/hamburger";
import Menus from "../../components/hamburger/menus";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import { Navigate } from "react-router";
import MyCalendarViewCompany from "../../components/myCalendar/myCalendarCompany";

const DashboardWrapper = styled.div`
  @media (max-width: 1024px) {
    display: flex;
  }
`;

const HamburgerLayout = styled.div`
  @media (min-width: 1025px) {
    display: none;
  }
`;
const HeaderText = styled.h2`
  // margin-top:-20px;
  margin-bottom:1%;
  font-family: 'General Sans';
  font-style: normal;
  font-weight: 500;
  font-size: 28px;
  line-height: 38px;
  color: #000000;
  padding:0 3rem;
  @media (max-width: 500px) {
  margin:20px 0 0 5px;
    }
`;

const CompanySection = styled.div`
  display: flex;
  margin-bottom: 20px;
  marginleft: "20px";
  padding:0 3rem;
  @media (max-width: 500px) {
    padding:0 1rem;
    display:block;
  }
`;

const SectionWrapper = styled.div`
  width: 100%;
  display: grid;
  grid-template-columns: 1fr 1fr 1fr;
  gap: 12px;
  padding:0 3rem;
  @media (max-width: 767px) {
    grid-template-columns: 1fr;
  }
  @media (max-width: 500px){
    padding:0 1rem;
  }
`;

const InputBox = styled.div`
  margin-top: 20px;
  margin-right: 20px;
  width: 90%;
  height: 54px;
  @media (max-width: 500px) {
    width: 100%;
  }
`;

export default function MyCalendar() {
  useSnapshot(mycalendarProxy);
  const styles = {
    control: (base, state) => ({
      ...base,
      height: "45px",
      padding: "5.5px 5px",
      transition: "none",
      textTransform: "capitalize",
      width: "100%",
      background: `${Colors.light}`,
      border: "0px",
      outline: "none",
      boxShadow: " inset 0px 0px 4px rgba(0, 0, 0, 0)",
      borderRadius: "128px",
      "&:hover": {
        boxShadow: "0 0 0 1px #ff60b1",
        borderColor: "#ff60b1",
      },
    }),
    menu: (base) => ({
      ...base,
      marginTop: "0px",

      outline: "none",
      zIndex: "3",
      textTransform: "capitalize",
      border: "0px solid white",
      transition: "none",
      // minWidth: "234px",
    }),
    menuList: (base) => ({
      ...base,
      color: "#575757;",
      fontSize: "12px",
      // minWidth: "234px",
      textTransform: "capitalize",
    }),
    option: (provided, state) => ({
      ...provided,
      width: "100%",
      height: "100%",
      fontSize: `14px`,
      fontFamily: `General Sans`,
      fontWeight: `500`,
      backgroundColor: state.isSelected ? `#D04C8D` : `transparent`,
      color: state.isSelected ? `white` : `#202020`,
      "&:hover": {
        backgroundColor: state.isSelected ? `#D04C8D` : `#FFE9F4`,
        Color: `#D04C8D`,
      },
    }),
    input: (base, state) => ({
      ...base,
      '[type="text"]': {
        color: `#575757; !important`,
      },
    }),
  };
  const [isOpenham, setOpenHam] = useState(false);
  const [userSearch, setUserSearch] = useState(false);
  const [task, setTask] = useState([]);
  const { t } = useTranslation();

  const [selectedModules,setSelectedModules] = useState({
    label: "Company",
    value: "company"
  })

  const [status,setStatus] = useState({
    label: "Pending",
    value: "pending"
  })

  const [filapplications, setFilapplications] = useState({
    label: "Interview",
    value: "interview",
  });
  const [tags, setTags] = useState({ label: "Tags", value: "-1" });

  const [search, setSearch] = useState("");
  useEffect(async () => {
    if(selectedModules.value === "company"){
      chkserCompany();
    } else {
      chkser();

    }
  
  }, [filapplications, tags]);


  const chkserCompany = (s) => {
    
    if (search.length == 0) {
      setTask(mycalendarProxy.companySchedules);
      // checkfilapp(mycalendarProxy.companySchedules);
    } else {
      let s = search.toLowerCase();
      let a = [];
          

      for (let i = 0; i < mycalendarProxy.companySchedules.length; i++) {
        
        if (
          mycalendarProxy.companySchedules[i]["interview_title"].toLowerCase().indexOf(s) != -1
           ||
          (mycalendarProxy.companySchedules[i]["engage_jobposition"] == undefined &&
            mycalendarProxy.companySchedules[i]["jobtitle"].toLowerCase().indexOf(s) != -1) ||
          (mycalendarProxy.companySchedules[i]["engage_jobposition"] &&
            mycalendarProxy.companySchedules[i]["engage_jobposition"]
              .toLowerCase()
              .indexOf(s) != -1)
        ) {
          a.push(mycalendarProxy.companySchedules[i]);
        }
      }
      setTask(a);
      // checkfilapp(a);
    }

    if (tags.value != "tags") {
    }
  };
  const chkser = (statusDrop) => {
    let filteredTasks = [];
  
    // Search functionality
    if (search.length == 0) {
      filteredTasks = mycalendarProxy.applist;
    } else {
      let s = search.toLowerCase();
      filteredTasks = mycalendarProxy.applist.filter(task => 
        task.title.toLowerCase().indexOf(s) !== -1
      );
    }
  
    // Dropdown filter for 'all', 'pending', 'completed'
    // if (status.value !== "tags") {
      if (statusDrop.value === "pending") {
        filteredTasks = filteredTasks.filter(task => task.status === "pending");
      } else if (statusDrop.value === "completed") {
        filteredTasks = filteredTasks.filter(task => task.status === "completed");
      }
      
      // No need to filter for 'all' as it should show everything
    // }
  
    // Set filtered tasks and trigger necessary checks
    setTask(filteredTasks);
    // checkfilapp(filteredTasks);
  };

  const checkfilapp = (al) => {
    
    if (filapplications.value != "-1") {
      let a = [];
      for (let i = 0; i < al.length; i++) {
        if (al[i]["status"] == filapplications.value) {
          a.push(al[i]);
        }
      }
      setTask(a);
      chktag(a);
    } else {
      chktag(al);
    }
  };

  const chktag = (al) => {
    if (tags.value != "-1") {
      let a = [];
      for (let i = 0; i < al.length; i++) {
        if (
          al[i]["engage_tag"] &&
          al[i]["engage_tag"].toLowerCase().indexOf(tags.value) != -1
        ) {
          a.push(al[i]);
        }
      }
      setTask(a);
    }
  };

  const getapp = async () => {
    const { data } = await getSchedules();
    if (data.status == 1) {
      
      let t = []
      for (let i = 0; i < data.data.length; i++) {
        let a = data.data[i]["start_date_time"]
        let b = data.data[i]["end_date_time"]
        if (
          a &&
          a.length > 0 &&
          b &&
          b. length 
         
        ){
          t.push(data.data[i])
        }
      }
      
      mycalendarProxy.applist = t;

      if (status.value === "pending") {
        t = t.filter(task => task.status === "pending");
        
      } else if (status.value === "completed") {
        

        t = t.filter(task => task.status === "completed");
      }
      setTask(t);

      // let l = [{ label: "Tags", value: "-1" }];
      // let ll = [];
      // for (let i = 0; i < t.length; i++) {
      //   if (
      //     t[i]["engage_tag"] &&
      //     t[i]["engage_tag"].length > 0
      //   ) {
      //     let a = t[i]["engage_tag"].split(",");
      //     for (let j = 0; j < a.length; j++) {
      //       if (ll.indexOf(a[j].toLowerCase().trim()) == -1) {
      //         l.push({ label: a[j].trim(), value: a[j].toLowerCase().trim() });
      //       }
      //     }
      //   }
      // }
      // mycalendarProxy.tags = l;
    }
  };

  const getAppCompany= async (id) => {
    const { data } = await getApplications(id);
    if (data.status == 1) {
      
      let t = []
      for (let i = 0; i < data.data.length; i++) {
        let a = data.data[i]["interview_startdatetime"]
        let b = data.data[i]["interview_enddatetime"]
        if (
          a &&
          a.length > 0 &&
          b &&
          b. length &&
          ["pending","shortlist","engage"].indexOf(data.data[i]['status'])==-1
        ){
          t.push(data.data[i])
        }
      }
      setTask(t);
      mycalendarProxy.companySchedules = t;
      // checkfilapp(t)

      // let l = [{ label: "Tags", value: "-1" }];
      // let ll = [];
      // for (let i = 0; i < t.length; i++) {
      //   if (
      //     t[i]["engage_tag"] &&
      //     t[i]["engage_tag"].length > 0
      //   ) {
      //     let a = t[i]["engage_tag"].split(",");
      //     for (let j = 0; j < a.length; j++) {
      //       if (ll.indexOf(a[j].toLowerCase().trim()) == -1) {
      //         l.push({ label: a[j].trim(), value: a[j].toLowerCase().trim() });
      //       }
      //     }
      //   }
      // }
      // mycalendarProxy.tags = l;
    }
  };


  const getUser = async () => {
    const { data } = await getTalentUserData();

    if (data && data.status === 1) {
      let id = data.data.id;
      if(selectedModules.value === "company"){
        await getAppCompany(id)
      }else{
        await getapp();
      }
    }
  };

  useEffect(async()=>{
getUser();
  },[selectedModules])

  useEffect(async () => {
    await getUser()
    
  }, [ mycalendarProxy.setcheck]);
  
  // redirect to dashboard if has not completed assessment
  const completion = useSelector((state) => {
    return state.profile.profilePercentage
  });

  // if (completion!=null & completion<100){
  //   Navigate('/dashboard');
  // }

  const handleSearchEvents = (events) => {
  setUserSearch(false)
  }

    return (
        <MainLayout>
          <DashboardWrapper>
            <HamburgerLayout>
              <HamburgerLay toggled={isOpenham} toggle={setOpenHam} />
            </HamburgerLayout>
            {isOpenham && <Menus onClose={() => setOpenHam(false)} />}
          </DashboardWrapper>
            <HeaderText>{t("My Calendar")}</HeaderText>
            <CompanySection>
        <InputBox>
          <Input
            color="#fff"
            //width="70%"
            placeholder={t("Search Keywords for Job Title or Name")}
            value={search}
            onChange={(e) => {
              setSearch(e.target.value);
            }}
          />
        </InputBox>
        <div className="hideSearchBars" style={{ marginLeft: "0px" }}>
          <Button
            onClick={()=>{
              
              if(selectedModules.value === "company"){
                chkserCompany()
              }else {
                chkser();
              }
              if(search.length > 0){

                setUserSearch(true)
              } else {
                setUserSearch(false)
              }
            }
              
              }
            style={{ cursor: "pointer" }}
            name={t("Search")}
          />
        </div>
      </CompanySection>
      <SectionWrapper>
      <Dropdown
          className="drop"
          name="Engage"
          search={true}
          options={[
            { label: t("Company"), value: "company" },
            { label: t("University"), value: "university" }
          ]}
          placeholder="Please Select some options"
          minWidth="auto"
          width="200px"
          isMulti={false}
          val={selectedModules?.value}
          label={t(selectedModules?.label)}
          id="drop"
          change={(e) => {
            setSelectedModules(e);

            // chkser();
          }}
        />
   {/* {  selectedModules.value === "company" ?   <Dropdown
          className="drop"
          name="Engage"
          search={true}
          options={[
            // { label: t("All"), value: "-1" },
            { label: t("Interview"), value: "interview" },
            { label: t("Application"), value: "pending" },
            { label: t("Shortlist"), value: "shortlist" },
            { label: t("Engage"), value: "engage" },
            { label: t("Offered"), value: "offered" },
            { label: t("To Hired"), value: "hire" },
            { label: t("Reject"), value: "reject" },
          ]}
          placeholder="Please Select some options"
          minWidth="auto"
          width="200px"
          isMulti={false}
          val={filapplications?.value}
          label={filapplications?.label}
          id="drop"
          change={(e) => {
            setFilapplications(e);

            chkserCompany();
          }}
        /> : <></>} */}
  
      {/* {selectedModules.value === "company" ?   <Dropdown
          name="Engage"
          search={true}
          options={mycalendarProxy.tags}
          placeholder="Please Select some options"
          minWidth="auto"
          width="200px"
          isMulti={false}
          val={tags?.value}
          label={tags?.label}
          id="drop"
          change={(e) => {
            setTags(e);
            chkser();
          }}
        /> : <></>} */}
             {selectedModules.value === "university" ?   
               <Dropdown
               className="drop"
               name="Engage"
               search={true}
               options={[
                //  { label: t("All"), value: "all" },
                 { label: t("Pending"), value: "pending" },
                 { label: t("Completed"), value: "completed" }
               ]}
               placeholder="Please Select some options"
               minWidth="auto"
               width="200px"
               isMulti={false}
               val={status?.value}
               label={status?.label}
               id="drop"
               change={(e) => {
                 setStatus(e);
     
                 chkser(e);
               }}
             /> : <></>}
       
      </SectionWrapper>
      <MyCalendarViewCompany handleSearchEvents={handleSearchEvents} searchValue={search} isSearching={userSearch} selectedModules={selectedModules} tasks={task}/>
        </MainLayout>
    )
}
